import { motion, AnimatePresence } from "framer-motion";
import { X, Heart } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { formatPrice } from "@/lib/api";
import { NotesPyramid } from "@/components/NotesPyramid";

export default function QuickViewModal() {
  const { quickView, setQuickView, addToCart, toggleWishlist, isWished } = useStore();
  const p = quickView;

  return (
    <AnimatePresence>
      {p && (
        <>
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            onClick={() => setQuickView(null)} className="fixed inset-0 z-[80] bg-ink/50 backdrop-blur-sm" />
          <div className="fixed inset-0 z-[90] flex items-center justify-center p-4 pointer-events-none">
            <motion.div
              data-testid="quickview-modal"
              initial={{ opacity: 0, scale: 0.94, y: 20 }} animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: 0.96, y: 10 }}
              transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
              className="relative pointer-events-auto w-full max-w-4xl bg-cream shadow-2xl border border-line grid grid-cols-1 md:grid-cols-2 max-h-[90vh] overflow-hidden"
            >
              <button data-testid="quickview-close-btn" onClick={() => setQuickView(null)}
                className="absolute top-4 right-4 z-10 w-10 h-10 flex items-center justify-center bg-cream/90 text-ink hover:text-mocha-dark transition-colors"><X size={20} strokeWidth={1.5} /></button>

              <div className="aspect-[3/4] md:aspect-auto bg-beige overflow-hidden">
                <img src={p.image} alt={p.name} className="w-full h-full object-cover" />
              </div>

              <div className="p-8 lg:p-10 flex flex-col overflow-y-auto">
                <p className="eyebrow text-mocha-dark mb-3">{p.brand} · {p.category}</p>
                <h3 className="font-serif text-4xl text-ink leading-tight">{p.name}</h3>
                <div className="flex items-baseline gap-3 mt-4">
                  <span className="text-2xl text-ink font-medium">{formatPrice(p.price)}</span>
                  {p.original_price ? <span className="text-ink-muted line-through">{formatPrice(p.original_price)}</span> : null}
                </div>
                <p className="text-ink-soft leading-relaxed mt-6">{p.description}</p>

                <div className="mt-8">
                  <NotesPyramid product={p} />
                </div>

                <div className="flex gap-3 mt-auto pt-8">
                  {p.stock <= 0 ? (
                    <span className="flex-1 py-4 bg-ink/10 text-ink-muted text-xs uppercase tracking-[0.2em] text-center cursor-not-allowed">Sold Out</span>
                  ) : (
                    <button data-testid="quickview-add-cart" onClick={() => { addToCart(p); setQuickView(null); }}
                      className="flex-1 py-4 bg-ink text-cream text-xs uppercase tracking-[0.2em] hover:bg-mocha-dark transition-colors">Adaugă în coș</button>
                  )}
                  <button data-testid="quickview-wishlist" onClick={() => toggleWishlist(p)}
                    className={`w-14 flex items-center justify-center border transition-colors ${isWished(p.id) ? "border-[#C1362F] text-[#C1362F]" : "border-line text-ink hover:border-ink"}`}>
                    <Heart size={18} strokeWidth={1.5} fill={isWished(p.id) ? "#C1362F" : "none"} />
                  </button>
                </div>
              </div>
            </motion.div>
          </div>
        </>
      )}
    </AnimatePresence>
  );
}
